export class CalculationAssistant {
  lines: Totals = new Totals();
  hours: Totals = new Totals();
  total: Totals = new Totals();
  startingFee: number = 0;
  companySettings: CompanySettings = new CompanySettings();
  contribution: Contribution = new Contribution();
  customer: Customer = new Customer();
  hourAmount: number = 0;
  currencyMask = {
    align: "right",
    allowNegative: true,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "",
    suffix: "",
    thousands: ".",
    nullable: false
  };
  ratioMask = {
    align: 'right',
    allowNegative: true,
    allowZero: true,
    decimal: ',',
    precision: 1,
    prefix: '',
    suffix: '',
    thousands: '.',
    nullable: false
  }
  private currency: string = 'DKK';
  language: string = 'da-DK';

  public async updateContribution() {
    this.contribution.margin = await (this.customer.price * 0.8) - this.total.cost;
    if (this.total.cost != 0) { this.contribution.ratio = (((this.customer.price * 0.8) / this.total.cost) - 1) * 100 }
    else {
      this.contribution.ratio = 0;
    }
  }

  public async updateTotals() {
    this.total.cost = await this.lines.cost;
    this.total.sales = await this.lines.sales;
    this.customer.price = await this.total.sales * 1.25;
    await this.updateContribution();
  }

  //public getProductProfitMargin() {
  //  var margin = (this.total.sales - this.lines.sales) / this.products.cost
  //  return (margin - 1) * 100
  //}

  public numsCurrency(x) {
    return new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(x);
  }

  public nums(x) {
    return new Intl.NumberFormat(this.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(x);
  }

  public intNums(x) {
    return new Intl.NumberFormat(this.language, { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(x);
  }

  public intNumsInThousands(x) {
    if (x < 1000) return (x / 1000).toFixed(1);
    if (x >= 1000) return +(x / 1000).toFixed(1);
  }

  public numsDecimals(number, decimalCount) {
    return (+number).toFixed(decimalCount);
  }

  public setCurrency() {
    switch (this.language) {
      case ('da-DK'): { this.currency = 'DKK'; break }
      case ('sv-SE'): { this.currency = 'SEK'; break }
      case ('de-DE'): { this.currency = 'EUR'; break }
      case ('fo-FO'): { this.currency = 'DKK'; break }
      case ('es-ES'): { this.currency = 'EUR'; break }
      case ('en-US'): { this.currency = 'USD'; break }
      case ('nn-NO'): { this.currency = 'NOK'; break }
      default: { this.currency = 'DKK'; break }
    }
  }
}

export class Totals {
  'cost': number = 0;
  'sales': number = 0;
}

export class Contribution {
  ratio: number = 0;
  margin: number = 0;
}

export class TaxReduction {
  applicable: boolean = false;
  type: string = 'rot';
  amount: number = 0;

  updateTaxReductionAmount(workHoursCostPrice: number) {
    if (this.type == 'rot') { this.amount = (+(workHoursCostPrice * 0.3).toFixed()) }
    if (this.type == 'rut') { this.amount = (+(workHoursCostPrice * 0.5).toFixed()) }
  }
}

export class CompanySettings {
  profitMargin: number = 0;
  initialFee: number = 0;
}

export class Customer {
  personalIdentityNumber: string;
  propertyDescription: string;
  housingCoopIdentityNumber: string;
  price: number = 0;
}
